import {Fragment, useContext} from "react";
import {useParams} from 'react-router-dom';
import {GlobalContext} from "../admin-frame/AdminFrame";
import {ApiUtility} from "../common/ApiUtility";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {useModelUpdateEngine} from "../common/hooks/useModelUpdateEngine";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {BrokerForm} from "./BrokerForm";

type UpdateBrokerPageRouteParams = {
    brokerId: string;
}

export let UpdateBrokerPage = function () {
    const context = useContext(GlobalContext);
    const params = useParams<UpdateBrokerPageRouteParams>()
    const modelUpdateEngine = useModelUpdateEngine(
        ApiUtility.getBroker,
        ApiUtility.updateBroker,
        '' + params.brokerId,
        'broker',
        () => context.navigator.goBack(),
        {}
    );

    return (
        <Fragment>
            <ConditionalRenderer if={modelUpdateEngine.dataStore.data().loading} renderer={() => (
                <OverlayLoadingIndicator />
            )} />
            <ConditionalRenderer if={modelUpdateEngine.dataStore.data().model} renderer={() => (
                <BrokerForm
                    cancel={() => context.navigator.goBack()}
                    save={modelUpdateEngine.updateModel}
                    broker={modelUpdateEngine.dataStore.data().model}
                    isNew={false}
                />
            )} />
        </Fragment>
    );
};
